"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _framerMotion = require("framer-motion");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useAccordionAnimation = require("../common/useAccordionAnimation");
var HBNewTableExpandedRow = function HBNewTableExpandedRow(_ref) {
  var item = _ref.item,
    colSpan = _ref.colSpan,
    renderComponent = _ref.renderComponent,
    isRowExpanded = _ref.isRowExpanded;
  var animation = (0, _useAccordionAnimation.useAccordionAnimation)();
  var actualComponent = renderComponent(item);
  return /*#__PURE__*/_react["default"].createElement(StyledTr, null, /*#__PURE__*/_react["default"].createElement(StyledTd, {
    colSpan: colSpan
  }, /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
    initial: false
  }, isRowExpanded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(MotionWrapper, animation, actualComponent), /*#__PURE__*/_react["default"].createElement(MotionWrapperHidden, animation, actualComponent)))));
};
var _default = exports["default"] = HBNewTableExpandedRow; // --- Styles ---
var StyledTr = _styledComponents["default"].tr.withConfig({
  displayName: "HBNewTableExpandedRow__StyledTr",
  componentId: "sc-w1oxhm-0"
})([""]);
var StyledTd = _styledComponents["default"].td.withConfig({
  displayName: "HBNewTableExpandedRow__StyledTd",
  componentId: "sc-w1oxhm-1"
})(["padding:0;"]);
var MotionWrapper = (0, _styledComponents["default"])(_framerMotion.motion.div).withConfig({
  displayName: "HBNewTableExpandedRow__MotionWrapper",
  componentId: "sc-w1oxhm-2"
})(["position:absolute;left:0;width:100%;"]);
var MotionWrapperHidden = (0, _styledComponents["default"])(_framerMotion.motion.div).withConfig({
  displayName: "HBNewTableExpandedRow__MotionWrapperHidden",
  componentId: "sc-w1oxhm-3"
})(["opacity:0;pointer-events:none;"]);
//# sourceMappingURL=HBNewTableExpandedRow.js.map